import React, { useEffect, useState } from "react";
import CustomTable from "../../Components/Table/CustomTable";

import { Grid } from "@mui/material";
// import AllUserListCreateModal from "./Modal/AllUserListCreateModal";
import AllUserTableViewModal from "./Modal/AllUserTableViewModal";
import actions from "../../ReduxStore/actions/index";
import { useDispatch, useSelector } from "react-redux";
import UserCreateByOperatorModal from "../Operator/Modal/UserCreateByOperatorModal";
import { setHeaderName, setSubHeaderName } from "../../ReduxStore/Slices/headerSlice";
import image from "../../Assets/gold-bars-background-free-photo.jpg"
import AllUserListEditModal from "./Modal/EditModal/AllUserListEditModal";

const AllUserList = () => {
  const dispatch = useDispatch();

  const tableData = [
    {
      Name: "Vallarasu",
      Email: "valla@gmail.com",
      MobileNumber: "1232343444",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Pravin",
      Email: "pravin@gmail.com",
      MobileNumber: "98787687687",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Shahul",
      Email: "shahul@gmail.com",
      MobileNumber: "123322443543",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Ramesh",
      Email: "Ramesh@gmail.com",
      MobileNumber: "76575675664",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Sanjeev",
      Email: "Sanjeev@gmail.com",
      MobileNumber: "909878789709",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
  ];
  const tableHeadData = [
    "S.No",
    "Customer Name",
    // "Customer Id",
    "Email Id",
    "Mobile Number",
    "User Type",
    "Status",
    "Purchase"
  ];

  const { getAllCustomersStatus } = useSelector(
    (state) => state?.getAllCustomersStatus
  );

  console.log(
    getAllCustomersStatus?.data,
    "getAllCustomersStatusgetAllCustomersStatus"
  );

  const { approveCustomer } = useSelector((state) => state?.approveCustomer);

  const { managementRegisterForCustomer } = useSelector(
    (state) => state?.managementRegisterForCustomer
  );
  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllCustomersStatus`,
      };
      await dispatch(actions.GETALLCUSTOMERSSTATUS(data1));
    };
    fetchData();
  }, [dispatch, approveCustomer, managementRegisterForCustomer]);

  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      customer_id: "--",
      email: "--",
      phone: "--",
      role: "--",
      approval_status: "--",
    },
  ]);

  useEffect(() => {
    const tempArr = [];
    getAllCustomersStatus?.data?.map((data, index) => {
      return tempArr.push({
        Name: `${data?.first_name} ${data?.last_name}`,
        customer_id: data?.customer_id,
        email: data?.email,
        phone: data?.phone,
        role: data?.role === "customer" ? "Individual" : data?.role,
        approval_status:
          data?.approval_status.charAt(0).toUpperCase() +
          data?.approval_status.slice(1),
      });
    });
    setRowTableData(tempArr);
  }, [
    dispatch,
    getAllCustomersStatus,
    approveCustomer,
    managementRegisterForCustomer,
  ]);

  React.useEffect(() => {
      dispatch(setHeaderName("Operator Registration"));
      dispatch(setSubHeaderName("All User List"));
    }, [dispatch]);



    const editData = {
      first_name: "John",
      type: "Admin",
      email: "john.doe@example.com",
      isVerified: true,
      phone: "1234567890",
      country: "USA",
      state: "California",
      city: "Los Angeles",
      zip_code: "90001",
      address_1: "123 Main St",
      address_2: "Apt 4B",
      image:{
        fileUrl: `uploads/images/${image}`,
        type: "image.png",
        progress: 100,
      },
    };

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    
    
    

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          title="User List"
          tableHeadData={tableHeadData}
          // modalName={AllUserListCreateModal}
          purchaseButton="purchaseButton"
          modalName={UserCreateByOperatorModal}
          // editModalName={AllUserListEditModal}
          editData={editData}
          allShowModal="allShowModal"
          tableEdit={permissions?.OperatorRegistration?.["All User List"]?.edit}
          dataCreate={permissions?.OperatorRegistration?.["All User List"]?.add}
          
          tableView="tableview"
          // tableView={permissions?.OperatorRegistration?.["All User List"]?.edit}
          userApprovalModel="userApprovalModel"
          modalVeiwName={AllUserTableViewModal}
          modalViewHeadingName="User Detail"
          modalHeadingName="Create User"
          options={[
            { label: "Individual", value: "Individual" },
            { label: "Financial Consultant", value: "finance_consultant" },
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default AllUserList;
